import Dashboard from "views/Dashboard.js";
import Calendar from "views/Calendar.js";
import UserPage from "views/User.js";
import Member from "views/Member";
import Coaching from "views/Coaching";
import ScriptNotes from "views/ScriptNotes";
import Campus from "views/Campus";
import Script2 from "views/Script2";
import FocusSheet from "views/FocusSheet";

var routes = [
  {
    path: "/account",
    name: "Account",
    title: "Account",
    component: UserPage,
    layout: "/admin",
    num: 1,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    title: "Dashboard",
    component: Dashboard,
    layout: "/admin",
    num: 2,
  },
  {
    path: "/calendar",
    name: "Calendar",
    title: "Calendar",
    component: Calendar,
    layout: "/admin",
    num: 3,
  },
  {
    path: "/crm",
    name: "Faculty Hub",
    title: "Faculty Hub",
    component: Member,
    layout: "/admin",
    num: 4,
  },
  {
    path: "/coaching",
    name: "Coaching",
    title: "Coaching",
    component: Coaching,
    layout: "/admin",
    num: 5,
  },
  {
    path: "/scripts/document",
    name: "Scripts",
    title: "Scripts",
    component: ScriptNotes,
    layout: "/admin",
    num: 6,
  },
  {
    path: "/teacherscripts/document",
    name: "Teacher Scripts",
    title: "Teacher Scripts",
    component: Script2,
    layout: "/admin",
    num: 7,
  },
  {
    path: "/campus",
    name: "Campus Information Hub",
    title: "Information Hub",
    component: Campus,
    layout: "/admin",
    num: 8,
  },
  {
    path: "/focussheet",
    name: "District Focus Sheet",
    title: "Focus Sheet",
    component: FocusSheet,
    layout: "/admin",
    num: 9,
  },
];
export default routes;
